import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WordingService } from './wording.service';
@NgModule({
  imports: [CommonModule],
  providers: [WordingService]
})
export class UtilsDictionariesModule { }
